<template>
    <section class="section-lesson-navigation" :class="color" v-if="nextRoute || previousRoute">
        <LayoutContained :class="padding">
            <ContentHeading
                v-if="heading"
                :heading="heading"
                :headingColor="headingColor"
                :headingComponent="headingComponent"
                :marginBottom="content ? 'mb-6' : 'mb-0'"
                :textCentered="textCentered"
            ></ContentHeading>
            <ContentText
                v-if="content"
                :html="content"
                :contentColor="contentColor"
                :textCentered="textCentered"
            ></ContentText>
            <div class="mt-4 flex gap-4">
                <div class="flex-grow"></div>
                <ButtonPrimary
                    v-if="previousRoute"
                    :buttonRoute="previousRoute"
                    buttonText="Previous"
                ></ButtonPrimary>
                <ButtonPrimary
                    v-if="nextRoute"
                    :buttonRoute="nextRoute"
                    buttonText="Next"
                ></ButtonPrimary>
            </div>
        </LayoutContained>
    </section>
</template>

<script>
export default {
    name: 'SectionLessonNavigation',
    props: {
        lesson: {
            required: true,
            type: Object,
            default () {
                return {};
            },
        },
        nextRoute: {
            type: Object,
            default () {
                return null;
            },
        },
        previousRoute: {
            type: Object,
            default () {
                return null;
            },
        },
        padding: {
            required: false,
            default: 'py-12 sm:py-14',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-50',
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-gray-600',
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h3',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    computed: {
        heading () {
            if (this.nextRoute?.name === 'videos-lessonSlug') {
                let nextLessonTitle = this.lesson?.lesson_course?.course_next_lesson?.lesson_title;
                return nextLessonTitle ? 'Next Up: ' + nextLessonTitle : 'Next Up';
            }
            return 'Course Completed!';
        },
        content () {
            if (this.nextRoute?.name === 'videos-lessonSlug') {
                return '<p>Well done! Let\'s jump into the next lesson of the course.</p>';
            }
            if ((this.nextRoute?.name === 'courses-courseSlug')) {
                return '<p>Well done! Let\'s jump into the next course in this pathway.</p>';
            }
            return '<p>Well done, you have completed the course.</p>';
        },
    },
};
</script>
